import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/long-video-to-shorts")({
  beforeLoad: () => {
    throw redirect({ to: "/tools/long-video-to-short-video", statusCode: 301 })
  },
})
